import { ColDef, ColGroupDef } from "ag-grid-community";
import { SCAttributes } from "../../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../../common/generic/generic-sc-domain";
import { AgFormat } from "../../../common/utils/agGridFormat";
import { Functions } from "../../../common/utils/clientlistHelper";
import { hlinkFunction } from "../../grid/helpers";

export type GridHeader = ColDef | ColGroupDef;

const configEnableTrue: GridHeader = {
  enablePivot: true,
  rowGroup: true,
};
const kpiHeader = "kpi-header";
// tslint:disable-next-line:no-big-function
export function getAttributesColumnDefs() {
  return [
    {
      cellRenderer: hlinkFunction as any,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LEID,
      headerName: "Final Com LE Id",
    },
    {
      cellRenderer: hlinkFunction,
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LENAME,
      headerName: "Final Com LE Name",
    },
    {
      ...configEnableTrue,
      field: "client_subgrpid",
      headerName: "Final Com SubGrp Id",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_SUBGROUPNAME,
      headerName: "Final Com SubGrp Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_GRPID,
      headerName: "Final Com Grp Id",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_GROUPNAME,
      headerName: "Final Com Grp Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_COM_ID,
      headerName: "Final Com EC Id",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_FULLNAME,
      headerName: "Final Com EC Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL1,
      headerName: "Product Level 1",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL2,
      headerName: "Product Level 2",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL3,
      headerName: "Product Level 3",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SUBMNEMO,
      headerName: "Trader Sub Business Unit Mnemo",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_LABEL,
      headerName: "Trader Profit Center",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_PC,
      headerName: "Trader Profit Center Mnemo",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      headerName: "Client Country",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_EC_COM_CTRY,
      headerName: "Client EC country",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_SALESBEN_SALES,
      headerName: "Sales",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_SALESBEN_TEAM,
      headerName: "Sales Team",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SSBL,
      headerName: "Trader Sub Sub Business Line",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_SBU,
      headerName: "Trader Sub Business Unit",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SSBL,
      headerName: "Sales Sub Sub Business Line",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_LABEL,
      headerName: "Sales Profit Center",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_PCMNEMO,
      headerName: "Sales Profit Center Mnemo",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_OE_RES_REG_CODE,
      headerName: "Originating Region",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_BE_SHORT_LABEL,
      headerName: "Booking Entity",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_GOP,
      headerName: "Sales Operating Group",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_REGION,
      headerName: "Sales Region",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_ZONE,
      headerName: "Sales Zone",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SALES_COUNTRY,
      headerName: "Sales Country",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L1,
      headerName: "Business Level 1",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L2,
      headerName: "Business Level 2",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_BUSINESS_L3,
      headerName: "Business Level 3",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_BE_SHORT_MNEMO,
      headerName: "Booking Entity Mnemo",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPO_L1,
      headerName: "Client - LE - Typology Level 1",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPEL2_NAME,
      headerName: "Client - LE - Typology Level 2",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_TYPEL3_NAME,
      headerName: "Client - LE - Typology Level 3",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_REG_NAME,
      headerName: "Client - LE - Region Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_SUBREG_NAME,
      headerName: "Client - LE - Sub Region Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLIENT_LE_CTRY_GRP_NAME,
      headerName: "Client - LE - Country Grouping Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FINAL_CLIENT_CAMBIST_NAME,
      headerName: "Client - EC - Cambist Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_BUSTYPE,
      headerName: "Business Type",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_TRADE_BE_SHORT_MNEMO,
      headerName: "Trader Booking Entity Mnemo",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_CATEGORY_NAME,
      headerName: "Product Category Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_PRODUCT_LEVEL4,
      headerName: "Product Level 4",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARKDEALS_PRODUCT_FAMILY_NAME,
      headerName: "Product Family Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARKDEALS_EQYFI,
      headerName: "Equity/fixed Income Deals",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_NOMINAL_CURRENCY,
      headerName: "Nominal Currency",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_NEGOTIATED_CURRENCY,
      headerName: "Negotiated Currency",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_COUNTRY,
      headerName: "Mandate Country",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_REGION,
      headerName: "Mandate Region",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MANDATE_ZONE,
      headerName: "Mandate Zone",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_MARK_IS_ELEC,
      headerName: "Is Elec",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_AGENCY_DR_NAME,
      headerName: "Agency DR Name",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY,
      headerName: "Deal Currency",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY_EMG10,
      headerName: "Deal Currency EM/G10",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_CLI_MARK_CURRENCY_ZONES,
      headerName: "Deal Currency Zones",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_SBUMNEMO,
      headerName: "Sales - sub business unit",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_FPV_TRADE_INVFLOWFIN,
      headerName: "FPV Trd - Inv. Sol./Flow/Fin.",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_TEAM_ACTIVITY,
      headerName: "Team Activity Label",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_TEAM_DESK,
      headerName: "Team Desk Label",
    },
    {
      ...configEnableTrue,
      field: SCAttributes.SC_DEAL_X_ONE_INSTRUMENT,
      headerName: "Deal - X-One Instrument",
    },
  ];
}

const kpisDefaultColumnsDef = {
  aggFunc: "sum",
  enableValue: true,
  headerClass: kpiHeader,
  maxWidth: 250,
  minWidth: 50,
  valueFormatter:
    'Math.floor(value).toString().replace(/(\\d)(?=(\\d{3})+(?!\\d))/g, "$1,")',
  valueParser: "Number(newValue)",
};

// tslint:disable-next-line:no-big-function
export function getKpisColumnDefs() {
  return [
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_YTD,
      headerName: "SC YTD (K€)",
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.calculateNbiVar as any,
      comparator: AgFormat.AgNumberComparatorNumeric,
      enableValue: true,
      field: "sc_ytd_var_yoy",
      headerClass: kpiHeader,
      headerName: "SC YTD var YoY",
      maxWidth: 250,
      minWidth: 50,
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_YTD_1,
      headerName: "SC YTD-1 (K€)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_NOMINAL_YTD,
      headerName: "Nominal",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_FY,
      headerName: "SC FY",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_FY_1,
      headerName: "SC FY-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_VOLUMES_YTD,
      headerName: "Volumes YTD",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_VOLUMES_YTD_1,
      headerName: "Volumes YTD-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_MTD,
      headerName: "SC MTD (K€)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: "sc_mtd_1",
      headerName: "SC MTD-1 (K€)",
    },
    {
      aggFunc: "sum",
      cellRenderer: Functions.calculateNbiVar as any,
      comparator: AgFormat.AgNumberComparatorNumeric,
      enableValue: true,
      field: "sc_mtd_yoy",
      headerClass: kpiHeader,
      headerName: "SC MTD var (%)",
      maxWidth: 250,
      minWidth: 50,
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_YTD_2,
      headerName: "SC YTD-2 (K€)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_YTD_3,
      headerName: "SC YTD-3 (K€)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: "sc_ytd_usd",
      headerName: "SC YTD (K$)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: "sc_ytd_usd_1",
      headerName: "SC YTD-1 (K$)",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_BUDGET_SALES,
      headerName: "Budget Sales",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_BUDGET_TEAM,
      headerName: "Budget Team",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_BUDGET_PC,
      headerName: "Budget Profit Center",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_BUDGET_SBU,
      headerName: "Budget Sub Business Unit",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_BUDGET_BU,
      headerName: "Budget Business Unit",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_MTD_STEP1,
      headerName: "SC MTD Step 1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_SC_2,
      headerName: "SC FY-2",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_COM_YTD,
      headerName: "Commission YTD",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_COM_YTD_1,
      headerName: "Commission YTD-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_CSA_YTD,
      headerName: "CSA YTD",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_CSA_YTD_1,
      headerName: "CSA YTD-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: "sc_fees_ytd",
      headerName: "Fees YTD",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_FEES_YTD_1,
      headerName: "Fees YTD-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_TRADPL_YTD,
      headerName: "Trading Pnl YTD",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_TRADPL_YTD_1,
      headerName: "Trading Pnl YTD-1",
    },
    {
      ...kpisDefaultColumnsDef,
      field: SCKpis.SC_MARKUP_YTD,
      headerName: "YTD Mark Up",
    },
  ];
}
